import * as React from 'react';
import { withIntl, IntlProps } from 'ha/i18n';
import { Typography } from 'ha/ui/next/Typography';

interface Props {
  wrapperClassName?: string;
  titlesClassName?: string;
}

export const CitiesTitle: React.SFC<Props & IntlProps> = ({
  wrapperClassName,
  titlesClassName,
  intl: { T },
}) => (
  <div className={wrapperClassName}>
    <Typography.H2 component="h2" align="center" className={titlesClassName}>
      {T('Hundreds cities around the world!')}
    </Typography.H2>
    <Typography.H2 component="h2" align="center" className={titlesClassName}>
      {T('Where will you go?')}
    </Typography.H2>
  </div>
);

export default withIntl(CitiesTitle);
